export default "__VITE_ASSET__BrPY4a9X__"